







import Vue from 'vue';

export default Vue.extend({
    props: ['error'],
    layout: 'error', // you can set a custom layout for the error page
    created() {
        // if (this.error.statusCode === 504) {
        //   this.$router.push({
        //     name: '登录'
        //   })
        // }
    },
    mounted() {
        // 如果当前页面是exhibition-kw页面 && 是404, 则不上报fundebug
        if (
            window.location.href.includes('exhibition-kw') &&
            this.error.message.includes('This page could not be found')
        ) {
            console.log(
                '当前页面是exhibition-kw页面 && 是404, 则不上报fundebug'
            );
            return false;
        }

        const fundebug = require('fundebug-javascript');
        fundebug.notify(
            'ErrorCaptured',
            this.error.message + '-fundebug-1001',
            {
                metaData: this.error,
            }
        );
    },
    head: {
        title: '聚展网',
        meta: [
            {
                name: 'robots',
                content: 'noindex, nofollow',
            },
        ],
    },
});
